import { z } from 'zod';
import type { ParseResult, SchemaIssue } from '../voyage/schemas.js';
import { DENSITY_MAX } from './bunkering.js';
import {
  optAmount,
  optEnum,
  optId,
  optLocalTime,
  optNote,
  requiredIssues,
  resultOf,
} from './fields.js';

/**
 * Açılış bakiyesi (ADR 0117 §13; ortak belgesi §6 "Açılış bakiyesi"): defter gemi başına tank
 * başına onaylı açılışla başlar. Tarih saat, ölçüm, yoğunluk, MT, dayanak ve onay. Açılıştan önceki
 * raporlar deftere işlenmez (çift sayım ve BDN'siz alım olmaz). Saf modül.
 */

export const OPENING_METHODS = ['sounding', 'ullage', 'sensor', 'bdn', 'other'] as const;

export const fuelOpeningSchema = z.strictObject({
  tankId: z.uuid('INVALID_ID'),
  fuelTypeId: optId,
  measuredLocal: optLocalTime,
  method: optEnum(OPENING_METHODS),
  volumeM3: optAmount(),
  density15: optAmount({ positive: true, max: DENSITY_MAX }),
  massMt: optAmount(),
  /** Dayanak: ölçüm tutanağı, devir belgesi vb. (zorunlu; elle MT dayanaksız yazılmaz). */
  basis: optNote(500),
  remarks: optNote(500),
});
export type FuelOpeningInput = z.output<typeof fuelOpeningSchema>;

export const OPENING_REQUIRED = [
  'fuelTypeId',
  'measuredLocal',
  'method',
  'density15',
  'massMt',
  'basis',
] as const satisfies readonly (keyof FuelOpeningInput)[];

export function parseFuelOpening(input: unknown): ParseResult<FuelOpeningInput> {
  return resultOf(fuelOpeningSchema.safeParse(input));
}

export function openingSubmitIssues(value: FuelOpeningInput): SchemaIssue[] {
  return requiredIssues(value, OPENING_REQUIRED);
}
